import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery';

const isAllowedToCreate = (accessStatus: AccessStatus | null): boolean =>
	accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS ||
	accessStatus === AccessStatus.LICENSED_USE_ACCESS ||
	accessStatus === AccessStatus.EXTERNAL_COLLABORATOR_ACCESS;

export const useIsAllowedToCreateWhiteboard = (): boolean => {
	const { accessStatus } = useSessionData();

	return isAllowedToCreate(accessStatus);
};
